const host = `${window.location.protocol}//${window.location.host}`;

export function loadWorkers() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      // First we need to load the asset-manifest.json to find the path to the service worker
      console.log('Loading asset-manifest.json from:', `${host}/asset-manifest.json`);
      const response = await fetch(`${host}/asset-manifest.json`);

      if (response.ok === false) {
        console.error('Could not load asset-manifest.json');
        return;
      }
      const manifest = await response.json();
      const workerPath = manifest.files['cacheWorker.js'];

      if (!workerPath) {
        console.error('Could not find service worker path in asset-manifest.json');
        return;
      }

      const workerUrl = `${host}${workerPath}`;
      const registrations = await navigator.serviceWorker.getRegistrations();
      const existingRegistration = registrations.find(reg => reg.active?.scriptURL == workerUrl || reg.waiting?.scriptURL == workerUrl);

      await Promise.all(registrations
        .filter(reg => reg !== existingRegistration)
        .map(reg => {
          console.log('Unregistering service worker:', reg.active?.scriptURL);
          return reg.unregister();
        }));

      console.log({ registrations, existingRegistration });

      if (!existingRegistration) {
        console.log('Registering service worker:', workerUrl);
        const registration = await navigator.serviceWorker.register(workerUrl, { scope: '/' });
        console.log('Service Worker registered with scope:', registration.scope);
        return;
      }

      await existingRegistration.update();
    });
  }
}
